import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import { FaEye } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getUserName } from '../../utils/localStoarege';
import { getMedicineInvoiceApi, getMedicineStats } from '../../services/clinic/medicine_invoice';
import { formatDateTime } from '../../utils/FormatDateTime';
import ViewMedicinePdfModalFromComponent from '../../components/PdfViewer/ViewMedicinePdfModalFromComponent';
import Dropdown from '../../components/inputFields/DropDown';
import { accountUpdateMedicineStatus } from '../../services/account/change_mass_status';
import { IoMdRefresh } from 'react-icons/io';
import SearchBar from '../../components/searchBar/SearchBar';


function AccountMedicineInvoice() {
    const [cardData, setCardData] = useState([
        {
            title: "--",
            count: "--",
        },
        {
            title: "--",
            count: "--",
        },
    ]);

    const [tableData, setTableData] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState("");

    const headers = [
        { label: "Select", key: "checkbox" },
        { label: "ID", key: "id" },
        { label: "Name", key: "name" },
        { label: "Amount", key: "amount" },
        { label: "Status", key: "status" },
        { label: "Payment Mode", key: "mode" },
        { label: "Phone", key: "phone" },
        { label: "Date", key: "created_at" },
        { label: "Action", key: "action" },
        { label: "Transaction Number", key: "transaction_number" },
    ];
    const [searchText, setSearchText] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [pdfToDisplay, setPdfToDisplay] = useState({});


    const pageSize = 100;

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getMedicineInvoiceApi(query);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch Invoice");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Invoice:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchStats = async (centerName) => {
        try {
            let res = await getMedicineStats(centerName);
            if (res.status === 200) {
                setCardData([
                    {
                        title: "Total Amount Received",
                        count: res.data.total_amount_received,
                    },
                    {
                        title: "Total Invoices Generated",
                        count: res.data.total_invoices_generated,
                    },
                    {
                        title: "Online Paid",
                        count: res.data.online_paid,
                    },
                    {
                        title: "Cash Paid",
                        count: res.data.cash_paid,
                    },

                ]);
            } else {
                toast.error("Unable to fetch stats");
            }
        } catch (error) {
            console.error("Error fetching Stats:", error);
        }
    };

    useEffect(() => {
        fetchData("");
        fetchStats(getUserName());
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const openPdfModal = (values) => {
        setPdfToDisplay(values);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleRowSelect = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        if (selectedRows.length === tableData?.results?.length) {
            setSelectedRows([]);
        } else {
            const allRowIds = tableData?.results?.map((item) => item.id);
            setSelectedRows(allRowIds);
        }
    };

    const handleSave = async () => {
        try {
            const value = { ids: selectedRows, status: approvalStatus, };
            let res = await accountUpdateMedicineStatus(value);
            if (res.status === 200) {
                toast.success(res.data.message);
                setSelectedRows([]);
                setSelectAll(false);
                fetchData("");
            } else {
                toast.error("Error Updating Status");

            }
        } catch (error) {
            console.error("Error Updating Invoice:", error);
        }
    };

    const toggleSelectAll = () => {
        setSelectAll((prev) => !prev);
        if (!selectAll) {
            const allRowIds = tableData?.results?.map((item) => item.id) || [];
            setSelectedRows(allRowIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData("&search=" + query);
    };

    const resetSearch = () => {
        setSearchText("");
        fetchData("");
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home' },
            { name: 'Medicine Invoice' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Invoice"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"History"} />
            <div className="flex flex-row justify-end items-center gap-3">
                {selectedRows.length > 0 && (
                    <div className="flex items-center space-x-4">
                        <Dropdown
                            placeholder="Select Status"
                            options={[
                                { label: "Approved", value: "Approved" },
                                { label: "Pending", value: "Pending" },
                            ]}
                            onChange={(value) => setApprovalStatus(value)}
                        />
                        <button
                            className="bg-primary text-white px-4 py-2 rounded"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    </div>
                )}
                <button
                    className="bg-gray-500 text-white px-4 py-2 rounded"
                    onClick={toggleSelectAll}
                >
                    {selectAll ? "Deselect All" : "Select All"}
                </button>
            </div>
        </div>
        <div className="flex flex-row items-center gap-3">
            <div className="md:w-[30%] lg:w-[20%] self-end mb-2">
                <SearchBar placeholder="Search Patients..." value={searchText} onSearch={handleSearch} />
            </div>
            {
                searchText !== "" ?
                    <IoMdRefresh size={23} className='text-primary cursor-pointer' onClick={resetSearch} /> : <></>
            }
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                checkbox: (
                                    <input
                                        type="checkbox"
                                        checked={selectedRows.includes(item.id)}
                                        onChange={() => handleRowSelect(item.id)}
                                    />
                                ),
                                id: <p>{index + 1}</p>, // Display sequential numbers starting from 1
                                status: <p>{item.status}</p>,
                                name: <p>{item.name}</p>,
                                amount: <p>{item.amount}</p>,
                                mode: <p>{item.mode}</p>,
                                phone: <p>{item.phone}</p>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                transaction_number: <p>{item.transaction_number}</p>,
                                action: (
                                    <span
                                        className="cursor-pointer self-center items-center justify-center"
                                        onClick={() => openPdfModal(item)}
                                    >
                                        <FaEye color="green" size={20} />
                                    </span>
                                ),
                            }
                        ))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
        <ViewMedicinePdfModalFromComponent contentLabel={"PDF"} isOpen={modalIsOpen} onRequestClose={closeModal} values={pdfToDisplay} />
    </>);
}

export default AccountMedicineInvoice;